import React, { useRef, useState, useEffect } from 'react';
import Phone_Ico from '../../../../Assets/Images/phone.png'
import { showToast } from '../../../../Component/Toast';
import axios from 'axios'
import Spinner from '../../../../Component/Loader'
import Button from '../../../../Component/Button'
import useClientHook from "../../../../Hooks/useClientHook";
import MultipleOrigins from '../../../../Component/MultipleOrigins/MultipleOrigins'
import Captcha from "../../../../Component/Captcha";

function Index() {

    let MOBILE = useRef(), OTP = useRef();
	const [LoginMessage, setLoginMessage] = useState();
    const [Mobile, setMobile] = useState(undefined);
    const [Loader, setLoader] = useState(undefined);
    const [BtnLoader, setBtnLoader] = useState(false);
	const [Recaptcha, setRecaptcha] = useState(undefined);
    const [OTPTimer, setOTPTimer] = useState();

    // Function to mask mobile number
    const maskMobile = (mobile) => {
        if (!mobile || mobile.length < 4) return mobile;
        const firstTwo = mobile.substring(0, 2);
        const lastTwo = mobile.substring(mobile.length - 2);
        const maskLength = mobile.length - 4;
        return `${firstTwo}${'*'.repeat(maskLength)}${lastTwo}`;
    }

    let params = new URLSearchParams(window.location.search)
	let {client_id, origin, logo, provider} = useClientHook('LOGIN')

    //Handling multiple origins for one user
	const [MultipleLogins, setMultipleLogins] = useState();
	const [SelectedOrigin, setSelectedOrigin] = useState(provider);
	const [Showorigins, setShoworigins] = useState();

    useEffect(() => {
		if(params.get('message')){
			setLoginMessage(params.get('message'))
            if(params.get('prefill')){
                setMobile(params.get('prefill'))
            }
		}
    }, [params]);

    const resendOTP = () => {
        axios.post(`https://auth.dice.tech/auth/employee/otp`, {mobile: Mobile, client_id,...(SelectedOrigin?{origin: SelectedOrigin}:undefined)}).then(res => {
            if(res.data.success){
                OTP.current.value = ''
                OTP.current.focus()
                showToast({
                    type: 'success',
                    message: "OTP has been resent"
                })
                setOTPTimer(60)
            }
        }).catch(err => {
            if(err.response){
                showToast({
                    type: 'error',
                    message: err.response.data.message
                })
            }else if(err.request){
                let msg = JSON.parse(err.request.response)
                showToast({
                    type: 'error',
                    message: msg.message
                })
            }
        })
    }

    const getOTP = () => {
        let mobile = MOBILE.current? MOBILE.current.value:undefined;

        if(!mobile){
            showToast({
                type: 'error',
                message: 'Enter mobile number'
            })
            return
        }
        setBtnLoader(true)
        axios.post(`https://auth.dice.tech/auth/employee/otp`, {mobile,client_id,...(SelectedOrigin?{origin: SelectedOrigin}:undefined)}).then(res => {
            if(res.data.success){
                setMobile(mobile)
                OTP.current.value = ''
                OTP.current.focus()
                setOTPTimer(60)
            }
            setLoader()
            setBtnLoader(false)

            //Checking if multile origins are present for this user and no origin is selected
            if(!SelectedOrigin && res.data.origins?.length){
                setMultipleLogins(res.data.origins)
                setShoworigins(true)
            }
        }).catch(err => {
            setBtnLoader(false)
            setLoader()
            if(err.response){
                if(typeof err.response.data === 'string'){
                    //let msg = JSON.parse(err.response.data)
                    //console.log(msg);
                    if(err.response.data.includes("Maximum 20 Mobile OTP is allowed")){
                        showToast({
                            type: 'error',
                            message: 'Maximum 20 Mobile OTP is allowed. Kindly connect to Dice Support Team'
                        })
                    }else {
                        showToast({
                            type: 'error',
                            message: err.response.data
                        })
                    }
                   
                }else{
                    showToast({
                        type: 'error',
                        message: err.response.data.message
                    })
                }
               
            }else if(err.request){
                let msg = JSON.parse(err.request.response)
                showToast({
                    type: 'error',
                    message: msg.message
                })
            }
        })
    }

    const submitForm = e => {

		let otp = OTP.current.value;

		if(!otp){
			showToast({
				type: 'error',
				message: "Please enter OTP"
			})
			return
		}

        if(!Recaptcha && !origin.includes('employee.dice.tech') && !origin.includes('app.dice.tech')){
			showToast({
				type: 'error',
				message: 'Please validate captcha'
			})
			return;
		}

		const form = document.createElement('form');
		form.method = "post";
		form.action = "https://auth.dice.tech/auth/employee/mobile";

		let params =  {
			mobile: Mobile,
            otp,
			referrer:window.location.origin,
            ...(client_id?{client_id:client_id}:undefined),
            ...(SelectedOrigin?{origin: SelectedOrigin}:undefined)
		}

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				const hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = key;
				hiddenField.value = params[key];
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);
		try{
            setLoader(true)
            form.submit();
        } catch (err){
            setLoader(undefined)
            showToast({
				type: 'error',
                message: err.response?err.response.data.message:"Something went Wrong !"
			})
        }

	}

    useEffect(() => {
        if(OTPTimer){
            let INTERVAL = setTimeout(() => {
                if(OTPTimer < 1){
                    setOTPTimer()
                }else{
                    setOTPTimer(prev=>prev-1)
                }
            }, 1000);
            
            return () => clearTimeout(INTERVAL);
        }
    }, [OTPTimer]);

    useEffect(() => {
        // Don't auto-call getOTP if there's an error message in URL params
        // This prevents infinite loading when user is redirected back with an error
		if(SelectedOrigin && client_id && !params.get('message')){
            setLoader(true)
		    setShoworigins()
			getOTP()
		}
        // eslint-disable-next-line
	}, [SelectedOrigin, client_id]);

    if(Loader || !client_id){
        return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background: '#fff'}}><Spinner/></div>
    }

    return (
       <div className="container position-relative" style={{height: '100vh'}}>
            <MultipleOrigins show={Showorigins} logins={MultipleLogins} onSelect={setSelectedOrigin}/>
            <div className="row justify-content-center h-100-center">
                <div className="col-md-6 pt-4">
                    <div className="p-3" style={{backgroundColor: '#fff', borderRadius: '1rem', maxWidth: 400, boxShadow: '0 1rem 2rem rgba(0,0,0,.5)!important', margin: 'auto'}}>
                    {
                        !Mobile?
                            <>
                            <img className="img-fluid mb-4" src={logo} alt='Lock' style={{maxHeight: 60}} />
                            <h1 className="display-6 fw-bold mb-0">Mobile</h1>
                            <p>Enter your registered number to continue</p>
                            <div className="mt-4 mb-4">
                                <div>
									<p className="label">
										Mobile Number:
									</p>
                                    <input ref={MOBILE} type="number" className="form-control mb-4" placeholder="Mobile Number" />
                                    {
                                        LoginMessage?
                                        <p className='text-danger text-left' style={{fontSize: '0.8rem', textAlign: 'left'}}>
                                            <svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
                                            </svg>
                                            {LoginMessage}
                                        </p>
                                        :<>

										 </>
                                    }
                                    <Button onClick={getOTP} name='Get OTP' loading={BtnLoader} />
                                </div>
                            </div>
                            </>
                        :<>
                            <img className="img-fluid mb-4" src={Phone_Ico} alt='Lock' style={{maxHeight: 60}} />
                            <h1 className="display-6 fw-bold">Enter OTP</h1>
                            <p>
                                An OTP has been sent to {maskMobile(Mobile)},&nbsp;
                                {
                                    OTPTimer?
                                    <span className='text-primary'>Resend OTP in {OTPTimer}s</span>:
                                    <span onClick={resendOTP} className='text-primary' style={{cursor: 'pointer'}}>Resend OTP</span>
                                }
                            </p>

                            <div className="mt-4 mb-4">
                                <div>
                                    <input ref={OTP} type="number" className="form-control mb-2" placeholder="enter otp" />
                                    {
                                        LoginMessage?
                                        <p className='text-danger text-left' style={{fontSize: '0.8rem', textAlign: 'left'}}>
                                            <svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
                                            </svg>
                                            {LoginMessage}
                                        </p>
                                        :<></>
                                    }
									<Captcha onChange={setRecaptcha} type={provider}/>
                                    <p className="mb-4" style={{fontSize:11,}}>
										We will send a <b>One-Time</b> password to your mobile number through SMS and Whatsapp.
									</p>
                                    <Button onClick={submitForm} name='Verify' loading={BtnLoader} />
                                </div>
                            </div>
                        </>
                    }
                        <p className="text-start" style={{fontSize: '0.9rem'}}>
                            <span>Login using&nbsp;&nbsp;&nbsp;</span>
                            <a className="text-primary" href={`/code?origin=${origin}&provider=${provider}`}>Code</a>&nbsp;&nbsp;
                            <a className="text-dark" href="/">|</a>&nbsp;&nbsp;
                            <a className="text-primary" href={`/?origin=${origin}&provider=${provider}`}>Email</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Index;
